import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.9412 9.26568C13.9088 2.18929 6.09073 2.18921 2.05835 9.26558C1.79891 9.72088 1.79891 10.279 2.05835 10.7343C6.09073 17.8107 13.9088 17.8108 17.9412 10.7344C18.2007 10.2791 18.2007 9.72097 17.9412 9.26568Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.7082 9.99999C12.7082 11.4958 11.4956 12.7083 9.99984 12.7083C8.50407 12.7083 7.2915 11.4958 7.2915 9.99999C7.2915 8.50422 8.50407 7.29166 9.99984 7.29166C11.4956 7.29166 12.7082 8.50422 12.7082 9.99999Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }